export const INVITATION_SECRET = 'lizardaposto01';
